import EventBg1 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-1.avif';
import EventBg2 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-2.avif';
import EventBg3 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-3.avif';
import EventBg4 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-4.avif';
import EventBg5 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-5.avif';
import EventBg6 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-6.avif';
import EventBg7 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-7.avif';
import EventBg8 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-8.avif';
import EventBg9 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-9.avif';
import EventBg10 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-10.avif';
import EventBg11 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-11.avif';
import EventBg12 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-12.avif';
import EventBg13 from '../Assets/Images/events-celebrations/pixerfect-event-celebration-photo-13.avif';
import Event1 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-1.avif';
import Event2 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-2.avif';
import Event3 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-3.avif';
import Event4 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-4.avif';
import Event5 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-5.avif';
import Event6 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-6.avif';
import Event7 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-7.avif';
import Event8 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-8.avif';
import Event9 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-9.avif';
import Event10 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-10.avif';
import Event11 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-11.avif';
import Event12 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-12.avif';
import Event13 from '../Assets/Images/events-celebrations/pixerfect-team-member-photo-13.avif';

const EventsAndCelebrationsList = [
  {
    title: 'Farm Day',
    eventImg: Event1,
    bgImg: EventBg1
  },
  {
    title: 'Ganesh Chaturthi',
    eventImg: Event2,
    bgImg: EventBg2
  },
  {
    title: 'Diwali',
    eventImg: Event3,
    bgImg: EventBg3
  },
  {
    title: 'TechTalks',
    eventImg: Event4,
    bgImg: EventBg4
  },
  {
    title: 'Holi Celebration',
    eventImg: Event5,
    bgImg: EventBg5
  },
  {
    title: 'Wellness Week',
    eventImg: Event6,
    bgImg: EventBg6
  },
  {
    title: 'Independence Day',
    eventImg: Event7,
    bgImg: EventBg7
  },
  {
    title: 'Saputara Trip 2024',
    eventImg: Event8,
    bgImg: EventBg8
  },
  {
    title: 'Shining Stars',
    eventImg: Event9,
    bgImg: EventBg9
  },
  {
    title: 'Farm Day',
    eventImg: Event10,
    bgImg: EventBg10
  },
  {
    title: 'Tech Session',
    eventImg: Event11,
    bgImg: EventBg11
  },
  {
    title: 'Ganesh Chaturthi',
    eventImg: Event13,
    bgImg: EventBg13
  },
  {
    title: 'Matheran Trip 2025',
    eventImg: Event12,
    bgImg: EventBg12
  }
];
export default EventsAndCelebrationsList;
